import useSWRMutationForm, { useErrorToSnackbar } from 'common-form/useSWRMutationForm';

import usePrequal from '../../resources/prequal/usePrequal';
import { transform as transformPhone } from '../InputPhone';
import { setMFATimeoutExpiration } from '../../hooks/useMFATimeout';
import usePrequalPhonesUpdate from '../../resources/prequalPhones/usePrequalPhonesUpdate';
import { PHONE_PRESENT_ON_EXISTING_ACCOUNT } from '../../constants';

const validation = {
  phone: ['Please enter a valid phone number.'],
};

const errorSchema = {
  COULD_NOT_VERIFY_PHONE: validation,
  PLATFORM_BAD_REQUEST: validation,
  [PHONE_PRESENT_ON_EXISTING_ACCOUNT]: {
    phone: ['Phone number already exists on different account.'],
  },
};

const useForm = (onDone) => {
  const { mutate: mutatePrequal } = usePrequal();

  const onSuccess = async (prequal) => {
    setMFATimeoutExpiration();
    await mutatePrequal(prequal, { revalidate: false });
    onDone();
  };

  return useSWRMutationForm({
    useMutation: () => usePrequalPhonesUpdate({ onSuccess }),
    onSubmit: (form) => ({ phone: transformPhone(form.phone) }),
    errorSchema,
    useUnhandledError: useErrorToSnackbar,
  });
};

export default useForm;
